/**
 * ProductOptionPicker - variant option picker coordinating option selectors.
 * Custom element: <product-option-picker>
 *
 * Attributes (from $info):
 *   product            Object  -
 *   variant-inventory  Object  -
 *
 * Refs:
 *   [data-ref="option1"]  (required)
 *   [data-ref="option2"]  (optional)
 *   [data-ref="option3"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ProductButtonOption } from "./component-ProductButtonOption.js";
import { ProductDropdownOption } from "./component-ProductDropdownOption.js";
import { ThemeComponent, AutoresolvingOptionSelector } from "./theme.js";
import { dist } from "./vendor.js";
import "./component-ProductOptionPicker.js";
import "./component-FakeDropdown.js";
class ProductOptionPicker extends ThemeComponent {
  constructor() {
    super(...arguments), this.selector = null, this._onSelectedVariantChange = new dist.SimpleEventDispatcher(), this.variantInventoryData = this.variantInventory, this.updateButtonDropdownStyles = option => {
      option instanceof ProductButtonOption ? (option.updateButtonStyles(), option.updateSelectedValueText()) : option instanceof ProductDropdownOption && (option.updateOptionLabels(), option.updateDropdownSelected());
    }, this.handleOptionChange = () => {
      this.updateButtonDropdownStyles(this.option1), this.updateButtonDropdownStyles(this.option2), this.updateButtonDropdownStyles(this.option3);
    };
  }
  get selectedVariant() {
    var option2Check, option3Check;
    const selectedValues = [this.option1.selected, ((option2Check = this.option2) == null ? void 0 : option2Check.selected) || null, ((option3Check = this.option3) == null ? void 0 : option3Check.selected) || null];
    return this.product.variants.filter(variant => variant.option1 == selectedValues[0] && variant.option2 == selectedValues[1] && variant.option3 == selectedValues[2])[0] || null;
  }
  get onSelectedVariantChange() {
    return this._onSelectedVariantChange.asEvent();
  }
  init() {
    this.selector = new AutoresolvingOptionSelector(this.product), this.$subscribe(this.option1.onChange, () => {
      this._onSelectedVariantChange.dispatch(this.selectedVariant), this.renderOptions();
    }), this.option2 && this.$subscribe(this.option2.onChange, () => {
      this._onSelectedVariantChange.dispatch(this.selectedVariant), this.renderOptions();
    }), this.option3 && this.$subscribe(this.option3.onChange, () => {
      this._onSelectedVariantChange.dispatch(this.selectedVariant), this.renderOptions();
    }), this.renderOptions();
  }
  renderOptions() {
    var option2Ref, option3Ref, option2ForUpdate, option3ForUpdate;
    if (this.selector && (this.selector.select(this.option1.selected, ((option2Ref = this.option2) == null ? void 0 : option2Ref.selected) || null, ((option3Ref = this.option3) == null ? void 0 : option3Ref.selected) || null), this.option1.updateBasedOnSelector(this.selector), (option2ForUpdate = this.option2) == null || option2ForUpdate.updateBasedOnSelector(this.selector), (option3ForUpdate = this.option3) == null || option3ForUpdate.updateBasedOnSelector(this.selector), this.$subscribe(this.option1.onChange, this.handleOptionChange), this.option2 && this.$subscribe(this.option2.onChange, this.handleOptionChange), this.option3 && this.$subscribe(this.option3.onChange, this.handleOptionChange), this.selector.wasSelectionModified)) {
      const resolvedSelection = this.selector.selected;
      this.option1.select(resolvedSelection[0].value), this.option2 && this.option2.select(resolvedSelection[1].value), this.option3 && this.option3.select(resolvedSelection[2].value), this._onSelectedVariantChange.dispatch(this.selectedVariant);
    }
  }
}
setFunctionName(ProductOptionPicker, "ProductOptionPicker");
const propertyTypes = {
  Object
};
ProductOptionPicker.prototype.$name = "ProductOptionPicker";
ProductOptionPicker.prototype.$info = JSON.parse('{"name":"ProductOptionPicker","meta":{"isLegacy":false,"selector":"product-option-picker"},"props":[{"attr":"product","reflectAttr":false,"propertyKey":"product","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"Shopify.Liquid.Product"},{"attr":"variant-inventory","reflectAttr":false,"propertyKey":"variantInventory","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"VariantInventory"}],"refs":[{"selector":"[data-ref=\\"option1\\"]","required":true,"propertyKey":"option1","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"ProductButtonOption | ProductDropdownOption"},{"selector":"[data-ref=\\"option2\\"]","required":false,"propertyKey":"option2","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"ProductButtonOption | ProductDropdownOption"},{"selector":"[data-ref=\\"option3\\"]","required":false,"propertyKey":"option3","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"ProductButtonOption | ProductDropdownOption"}]}');
ProductOptionPicker.prototype.$info.component = ProductOptionPicker;
for (const prop of ProductOptionPicker.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductOptionPicker.ts", {
  ProductOptionPicker: ProductOptionPicker
}, void 0);